import { createSlice } from "@reduxjs/toolkit";

export const settingSlice = createSlice({
  name: "settingState",
  initialState: {
    invoice_price: "usePrice",
  },
  reducers: {
    setGlobalSettings: (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        if (state.hasOwnProperty(key)) {
          state[key] = action.payload[key];
        }
      });
    },
  },
});
export const { setGlobalSettings } = settingSlice.actions;
export default settingSlice.reducer;
